import { render } from "./AllowedEnterprisesItem.vue?vue&type=template&id=107f0efa&ts=true"
import script from "./AllowedEnterprisesItem.vue?vue&type=script&lang=ts"
export * from "./AllowedEnterprisesItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__